module.exports = __webpack_public_path__ + "img/0-md.7e3ae3f1.jpg";